import { useEffect, useRef, useState } from 'react';
import { Box } from '@bridebook/ui';
import SignupLink from '@bridebook/web/app-shared/components/signup-link/signup-link';
import componentStyles from '@bridebook/web/app-shared/components/supplier/sections/instagram-widget/instagram-grid-item.style';
import { InstagramMedia } from '@bridebook/web/app-shared/lib/supplier/types';

interface IProps {
  isLoggedIn: boolean;
  photo?: InstagramMedia;
  onClick?: () => void;
  gap?: number;
}

export const INSTAGRAM_ITEMS_PER_ROW = {
  mobile: 3,
  desktop: 4,
};

const INSTAGRAM_ROWS = {
  mobile: 3,
  desktop: 2,
};

export const INSTAGRAM_MAX_ITEMS = {
  mobile: INSTAGRAM_ITEMS_PER_ROW.mobile * INSTAGRAM_ROWS.mobile,
  desktop: INSTAGRAM_ITEMS_PER_ROW.desktop * INSTAGRAM_ROWS.desktop,
};

export const InstagramGridItem = ({ isLoggedIn, photo, onClick, gap = 1 }: IProps) => {
  const [loaded, setLoaded] = useState(false);
  const imageRef = useRef<HTMLImageElement | null>(null);

  const styles = componentStyles({ gap });

  useEffect(() => {
    // Fix for an issue when onLoad doesn't trigger with images from SSR
    if (imageRef.current?.complete) setLoaded(true);
  }, []);

  return (
    <Box style={styles.imageWrap}>
      <SignupLink isLoggedIn={isLoggedIn} onClick={onClick} noAnalytics>
        {!loaded && <Box style={styles.loader} />}
        {photo && (
          <img
            ref={imageRef}
            src={photo.thumbnailUrl}
            alt=""
            style={styles.image}
            onLoad={() => setLoaded(true)}
          />
        )}
      </SignupLink>
    </Box>
  );
};
